// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getUserProfile = createAsyncThunk('appChat/getTasks', async () => {
  const response = await axios.get('/apps/chat/users/profile-user')
  return response.data
})

export const getChatContacts = createAsyncThunk('appChat/getChatContacts', async () => {
  const response = await axios.post('https://api.fntpf.ir/admin/getqueries')
  console.log(response.data.chats)
  return response.data.chats
})

export const getContactInfo = createAsyncThunk('appChat/getContactInfo', async (phone) => {
  const response = await axios.post('https://api.fntpf.ir/admin/getUser', {phone})
  return response.data.user
})

// export const getChatReplies = createAsyncThunk('appChat/getChatContacts', async () => {
//   const response = await axios.post('https://api.fntpf.ir/tickets/replies')
//   // console.log(response.data.chats)
//   return response.data.allData
// })

export const selectChat = createAsyncThunk('appChat/selectChat', async (id) => {
  const response = await axios.post('https://api.fntpf.ir/tickets/replies', { query: id })
  return response.data.allData
})

export const changeStatus = createAsyncThunk('appChat/changeStatus', async (info, { dispatch }) => {
  const response = await axios.post('https://api.fntpf.ir/tickets/admin/changeStatus', {info})
  await dispatch(getChatContacts())
  return response.data
})

export const sendMsg = createAsyncThunk('appChat/sendMsg', async (obj, { dispatch }) => {
  console.log(obj)
  const response = await axios.post('https://api.fntpf.ir/admin/tickets/newreply', obj)
  await dispatch(selectChat(obj.queryId))
  return response.data
})

export const appChatSlice = createSlice({
  name: 'appChat',
  initialState: {
    chats: [],
    contactInfo: {},
    contacts: [],
    userProfile: {},
    selectedQuery: [],
    test: {}
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getUserProfile.fulfilled, (state, action) => {
        state.contactInfo = action.payload
      })
      .addCase(getChatContacts.fulfilled, (state, action) => {
        state.chats = action.payload
        state.contacts = action.payload.contacts
      })
      .addCase(selectChat.fulfilled, (state, action) => {
        state.selectedQuery = action.payload
      })
      .addCase(getContactInfo.fulfilled, (state, action) => {
        state.userProfile = action.payload
      })
      .addCase(changeStatus.fulfilled, (state, action) => {
        state.test = action.payload
      })
  }
})

export default appChatSlice.reducer
